import {
  BalanceUpdate,
  CurrentPrice,
  Tick,
  TradeCommandType,
  TradeObject,
  TradeType,
} from '@bdswiss/mt4-connector'
import * as constants from '../constants'
import { Action } from 'redux'

export interface OpenTradeAction extends Action {
  type: constants.OPEN_TRADE
  // uuid?: string;
  // symbol: string;
  cmd: TradeCommandType
  // volume?: number;
  // investment?: number;
  // leverage?: number;
  // platform?: string;
  // sl?: number
  // tp?: number
}

export function openTrade(cmd: TradeCommandType): OpenTradeAction {
  return {
    type: constants.OPEN_TRADE,
    // symbol: "EURUSD",
    cmd,
    // investment: 9,
    // leverage: 10,
  }
}

export interface FulfillTickAction extends Action {
  type: constants.FULFILL_TICK
  ticks: Map<string, Tick>
}

export function fulfillTick(ticks: Map<string, Tick>): FulfillTickAction {
  return {
    type: constants.FULFILL_TICK,
    ticks,
  }
}

export interface FulfillOpenTradeAction extends Action {
  type: constants.FULFILL_OPEN_TRADE
  tradeObject: TradeObject
}

export function fulfillOpenTrade(tradeObject: TradeObject): FulfillOpenTradeAction {
  return {
    type: constants.FULFILL_OPEN_TRADE,
    tradeObject,
  }
}

export interface FulfillPendingTradeAction extends Action {
  type: constants.FULFILL_PENDING_TRADE
  tradeObject: TradeObject
}

export function fulfillPendingTrade(tradeObject: TradeObject): FulfillPendingTradeAction {
  return {
    type: constants.FULFILL_PENDING_TRADE,
    tradeObject,
  }
}

export interface FulfillActivatedTradeAction extends Action {
  type: constants.FULFILL_ACTIVATED_TRADE
  tradeObject: TradeObject
}

export function fulfillActivatedTrade(tradeObject: TradeObject): FulfillActivatedTradeAction {
  return {
    type: constants.FULFILL_ACTIVATED_TRADE,
    tradeObject,
  }
}

export interface FulfillCancelTradeAction extends Action {
  type: constants.FULFILL_CANCEL_PENDING_ORDER
  tradeObject: TradeObject
}

export function fulfillCancelTrade(tradeObject: TradeObject): FulfillCancelTradeAction {
  return {
    type: constants.FULFILL_CANCEL_PENDING_ORDER,
    tradeObject,
  }
}

export interface FulfillModifyPendingTradeAction extends Action {
  type: constants.FULFILL_MODIFY_PENDING_TRADE
  tradeObject: TradeObject
}

export function fulfillModifyPendingTrade(tradeObject: any): FulfillModifyPendingTradeAction {
  return {
    type: constants.FULFILL_MODIFY_PENDING_TRADE,
    tradeObject,
  }
}

export interface FulfillCloseTradeAction extends Action {
  type: constants.FULFILL_CLOSE_TRADE
  tradeObject: TradeObject
}

export function fulfillCloseTrade(tradeObject: any): FulfillCloseTradeAction {
  return {
    type: constants.FULFILL_CLOSE_TRADE,
    tradeObject,
  }
}

export interface ModifyTradeAction extends Action {
  type: constants.MODIFY_TRADE
  order: number
  uuid?: string
  sl?: number
  tp?: number
  price?: number
  tradeType?: TradeType
}

export function modifyTrade(
  order: number,
  uuid?: string,
  sl?: number,
  tp?: number,
  tradeType?: TradeType,
  price?: number
): ModifyTradeAction {
  return {
    type: constants.MODIFY_TRADE,
    order,
    uuid,
    sl,
    tp,
    price,
    tradeType,
  }
}

export interface FulfillModifyTradeAction extends Action {
  type: constants.FULFILL_MODIFY_TRADE
  tradeObject: TradeObject
}

export function fulfillModifyTrade(tradeObject: any): FulfillModifyTradeAction {
  return {
    type: constants.FULFILL_MODIFY_TRADE,
    tradeObject,
  }
}

export interface FulfillCurrentPricesAction extends Action {
  type: constants.FULFILL_CURRENT_PRICES
  currentPrices: CurrentPrice[]
}

export function fulfillCurrentPrices(currentPrices: any): FulfillCurrentPricesAction {
  return {
    type: constants.FULFILL_CURRENT_PRICES,
    currentPrices,
  }
}

export interface FulfillBalanceUpdate extends Action, BalanceUpdate {
  type: constants.FULFILL_BALANCE_UPDATE
}

export function fulfillBalanceUpdate(balance: BalanceUpdate): FulfillBalanceUpdate {
  return {
    type: constants.FULFILL_BALANCE_UPDATE,
    ...balance,
  }
}

export interface CancelPendingOrderAction extends Action {
  type: constants.CANCEL_PENDING_ORDER
  order: number
  uuid?: string
}

export function cancelPendingOrder(order: number, uuid?: string): CancelPendingOrderAction {
  return {
    type: constants.CANCEL_PENDING_ORDER,
    order,
    uuid,
  }
}

export interface CloseTradeAction extends Action {
  type: constants.CLOSE_TRADE
  order: number
  uuid?: string
}

export function closeTrade(order: number, uuid?: string): CloseTradeAction {
  return {
    type: constants.CLOSE_TRADE,
    order,
    uuid,
  }
}

export interface CloseBondTradeAction extends Action {
  type: constants.CLOSE_TRADE
  order: number
  uuid?: string
}

export function closeBondTrade(order: number, uuid?: string): CloseBondTradeAction {
  return {
    type: constants.CLOSE_TRADE,
    order,
    uuid,
  }
}

export interface SetTradeType {
  type: constants.SET_TRADE_TYPE
  tradeType: TradeCommandType
}

export function setTradeType(tradeType: TradeCommandType): SetTradeType {
  return {
    type: constants.SET_TRADE_TYPE,
    tradeType,
  }
}

export interface SetAmount {
  type: constants.SET_AMOUNT
  amount: number
}

export function setAmount(amount: number): SetAmount {
  return {
    type: constants.SET_AMOUNT,
    amount,
  }
}

export interface InputAmount {
  type: constants.INPUT_AMOUNT
  amount: number
}

export function inputAmount(amount: number): InputAmount {
  return {
    type: constants.INPUT_AMOUNT,
    amount,
  }
}

export interface SetTakeProfit {
  type: constants.SET_TAKEPROFIT
  takeProfit: number
}

export function setTakeProfit(takeProfit: number): SetTakeProfit {
  return {
    type: constants.SET_TAKEPROFIT,
    takeProfit,
  }
}

export interface SetStopLoss {
  type: constants.SET_STOPLOSS
  stopLoss: number
}

export function setStopLoss(stopLoss: number): SetStopLoss {
  return {
    type: constants.SET_STOPLOSS,
    stopLoss,
  }
}

export interface SetPrice {
  type: constants.SET_PRICE
  price: number
}

export function setPrice(price: number): SetPrice {
  return {
    type: constants.SET_PRICE,
    price,
  }
}

export interface InputPositionSL {
  type: constants.INPUT_POSITION_STOPLOSS
  order: number
  stopLoss: number
}

export function inputPositionSL(order: number, stopLoss: number): InputPositionSL {
  return {
    type: constants.INPUT_POSITION_STOPLOSS,
    order,
    stopLoss,
  }
}

export interface InputPositionTP {
  type: constants.INPUT_POSITION_TAKEPROFIT
  order: number
  takeProfit: number
}

export function inputPositionTP(order: number, takeProfit: number): InputPositionTP {
  return {
    type: constants.INPUT_POSITION_TAKEPROFIT,
    order,
    takeProfit,
  }
}

export interface InputPositionPrice {
  type: constants.INPUT_POSITION_PRICE
  order: number
  price: number
}

export function inputPositionPrice(order: number, price: number): InputPositionPrice {
  return {
    type: constants.INPUT_POSITION_PRICE,
    order,
    price,
  }
}
